module.exports = __webpack_public_path__ + "img/ALL-COVER.242a7d00.png";